window.fshopDawnUpsell = true;
// Load the matching-product app before cart navigation, including delayed app scripts.
window.fshopPrepareMatchingPopup = window.fshopPrepareMatchingPopup || function () {
  if (!document.querySelector('pugs-bundle')) return Promise.resolve();
  if (window.fshopMatchingPopupReady) return window.fshopMatchingPopupReady;
  window.fshopMatchingPopupReady = (async () => {
    const load = async (file) => {
      const source = [...document.scripts].find(s => (s.src || s.dataset.src || '').split('?')[0].endsWith('/' + file));
      if (!source) return;
      const ready = file === 'bundle.js' ? customElements.get('pugs-bundle') : window.fshopSuggestProducts;
      if (ready) return;
      await new Promise(resolve => {
        const script = document.createElement('script');
        const timer = setTimeout(resolve, 4000);
        script.onload = script.onerror = () => { clearTimeout(timer); resolve(); };
        script.src = source.src || source.dataset.src;
        document.head.append(script);
      });
    };
    await load('bundle.js');
    await load('goes-well-with.js');
    const deadline = Date.now() + 4000;
    while (!document.querySelector('pugs-bundle[data-ready]') && Date.now() < deadline) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
  })().catch(() => {});
  return window.fshopMatchingPopupReady;
};
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        const matchingPopupReady = window.fshopPrepareMatchingPopup();

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else {
              await matchingPopupReady;
              if (window.fshopSuggestProducts && await window.fshopSuggestProducts(response)) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form', productVariantId: formData.get('id'), cartData: response,
                });
                this.error = false;
                return;
              }
              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
